const logoDefaultUrl = require('@/assets/images/logo-edeka-full@3x.png');
const logoGreenUrl = require('@/assets/images/logo-edeka-full@3x.png');

const cartCreditDefaultUrl = require('../assets/images/icon-credit-card@3x.png');
const cartCreditGreenUrl = require('../assets/images/icon-credit-card@3x.png');

const cartClientDefaultUrl = require('../assets/images/icon-client-card@3x.png');
const cartClientGreenUrl = require('../assets/images/icon-client-card@3x.png');

const outdoorPaymentApp = require('../assets/images/icon-payment-app-blue.png'); // icon-payment-app.png
const outdoorPaymentSms = require('../assets/images/icon-payment-sms-blue.png'); // icon-payment-sms.png
const outdoorPaymentCreditCard = require('../assets/images/icon-payment-creditcard-blue.png'); // icon-payment-creditcard.png
const outdoorPaymentNfc = require('../assets/images/icon-payment-nfc-blue.png'); // icon-payment-nfc.png

export default {
  iLogo: {
    defaultUrl: logoDefaultUrl,
    greenUrl: logoGreenUrl,
  },
  iCartCredit: {
    defaultUrl: cartCreditDefaultUrl,
    greenUrl: cartCreditGreenUrl,
  },
  iCartClient: {
    defaultUrl: cartClientDefaultUrl,
    greenUrl: cartClientGreenUrl,
  },
  iPaymentApp: {
    defaultUrl: outdoorPaymentApp,
  },
  iPaymentSms: {
    defaultUrl: outdoorPaymentSms,
  },
  iPaymentCC: {
    defaultUrl: outdoorPaymentCreditCard,
  },
  iPaymentNfc: {
    defaultUrl: outdoorPaymentNfc,
  },
};
